(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

(function ($) {
  "use strict";

  var Cover101Core = function ($scope, $) {
    this.$scope = $scope;
    this.$element = $scope.find('.pos-widget');
    this.init();
  };
  Cover101Core.prototype = {
    init: function () {
      var self = this;
      self.prepareForm();
      self.addItemToCart();
      self.initStickySidebar();
      self.disableButton();
      self.bindInputChange();
      self.bindResetFormFields();
    },
    disableButton: function () {
      $('#add-more-covers').prop('disabled', true);
    },
    enableButton: function () {
      $('#add-more-covers').prop('disabled', false);
    },
    bindInputChange: function () {
      var self = this;
      self.$element.find('input, select').on('change', function () {
        self.disableButton();
      });
    },
    bindResetFormFields: function () {
      var self = this;
      self.$element.find('#add-more-covers').on('click', function () {
        self.resetFormFields();
        // Scroll to the container #pos-widget
        $('html, body').animate({
          scrollTop: self.$element.offset().top
        }, 1000); // Adjust the duration as needed
      });
    },
    addItemToCart: function () {
      var self = this;
      self.$element.on('click', '#add-to-cart', function () {
        var $this = $(this);
        var product_id = self.$element.find('#duration').find(':selected').data('id');
        var duration = self.$element.find('#duration').val();
        var adults = parseInt(self.$element.find('#adult').val()) || 0;
        var juniors = parseInt(self.$element.find('#junior').val()) || 0;
        var countries = self.$element.find('input[name="country[]"]:checked').map(function () {
          return this.value;
        }).get();
        if (product_id === undefined || duration === '' || adults == 0 && juniors == 0 || countries.length === 0) {
          var alertHtml = '<div class="alert alert-warning alert-dismissible fade show" role="alert">' + 'Please make sure all required fields are selected.' + '<span class="btn-close" data-bs-dismiss="alert" aria-label="Close"></span>' + '</div>';
          self.$element.prepend(alertHtml);
          setTimeout(function () {
            self.$element.find('.alert').alert('close');
          }, 6000);
          return false;
        }
        var data = {
          action: 'add_cover101_item',
          product_id: product_id,
          duration: duration,
          adults: adults,
          juniors: juniors,
          countries: countries,
          nonce: pos_ajax_obj.nonce
        };
        $(document.body).trigger('adding_to_cart', [$this, data]);
        $.post(pos_ajax_obj.ajax_url.toString().replace('%%endpoint%%', 'add_to_cart'), data, function (response) {
          if (!response) {
            return;
          }

          // let cart_url = response.fragments.cart_url;
          // let i18n_view_cart = response.fragments.i18n_view_cart;

          let this_page = window.location.toString();
          this_page = this_page.replace('add-to-cart', 'added-to-cart');
          if (response.error && response.product_url) {
            window.location = response.product_url;
            return;
          }
          let fragments = response.fragments;
          let cart_hash = response.cart_hash;
          if (fragments) {
            $.each(fragments, function (key, value) {
              $(key).addClass('updating');
            });
          }
          setTimeout(function () {
            $('.mini-cart-header .mini-cart-inner').addClass('open');
          }, 1000);

          // if (!response.is_cart && $this.parent().find('.added_to_cart').size() === 0) {
          //     $this.after(' <button onclick="location.href=&apos;' + cart_url + '&apos;" class="pull-right added_to_cart wc-forward" title="' + i18n_view_cart + '">' + i18n_view_cart + '</button>');

          //     $this.after('<a href=\"' + pos_ajax_obj.checkout_url + '\" class="pull-right checkout-button button alt wc-forward\">Proceed to checkout</a>');

          // }

          if (fragments) {
            $.each(fragments, function (key, value) {
              $(key).replaceWith(value);
            });
          }
          $('.shop_table.cart').load(this_page + ' .shop_table.cart:eq(0) > *', function () {
            $('.shop_table.cart').stop(true).css('opacity', '1').unblock();
            $(document.body).trigger('cart_page_refreshed');
          });
          $(document.body).trigger('added_to_cart', [fragments, cart_hash, $this]);

          // Update mini-cart items
          $('.mini-cart-items').html(fragments.cart_items_count);
          self.resetFormFields();
          self.enableButton(); // Enable the button when addItemToCart is executed
          $(document).find('#more-covers').show();
        });
        return false;
      });
    },
    formatOption: function (option) {
      if (!option.id) {
        return option.text;
      }
      var textParts = option.text.split('|');
      var duration = textParts.length > 1 ? textParts[1].trim() : option.text;
      var $option = $('<div class="option-content">' + '<i class="icon fa fa-circle"></i>' + '<div>' + duration + '</div>' + (option.element.dataset.description ? '<div class="description">' + option.element.dataset.description + '</div>' : '') + '</div>');
      return $option;
    },
    resetFormFields: function () {
      var self = this;
      self.$element.find('#adult').val(0);
      self.$element.find('#junior').val(0);
      self.$element.find('input[name="country[]"]').prop('checked', false);
      self.$element.find('.adults-count').text(0);
      self.$element.find('.junior-count').text(0);
      self.$element.find('.country').text('');
      self.$element.find('.selectedduration').text('');
      self.$element.find('.basket-amount').html('<span class="woocommerce-Price-amount amount"><bdi><span class="woocommerce-Price-currencySymbol">$</span>0.00</bdi></span>');
      self.$element.find('select#duration').val('14 Days').trigger('change');
    },
    prepareForm: function () {
      var self = this;
      self.$element.find('#duration').select2({
        templateResult: this.formatOption.bind(this),
        templateSelection: this.formatOption.bind(this),
        dropdownParent: self.$element
      });
      self.$element.find('.selectedduration').text(self.$element.find('select#duration').val());
      self.$element.find('#adult, #junior').on('input', function () {
        this.value = this.value.replace(/[^0-9]/g, '');
        if (this.value > 100) {
          this.value = 100;
        }
        if (this.id === 'adult') {
          self.$element.find('.adults-count').text($(this).val());
        } else if (this.id === 'junior') {
          self.$element.find('.junior-count').text($(this).val());
        }
      });
      self.$element.find('input[name="country[]"]').on('change', function () {
        var selectedCountries = self.$element.find('input[name="country[]"]:checked').map(function () {
          return this.value;
        }).get().join(', ');
        self.$element.find('.country').text(selectedCountries);
      });
      self.$element.find('select#duration').on('change', function () {
        self.$element.find('.selectedduration').text($(this).val());
        self.getProductPrice();
      });
      self.$element.find('#adult, #junior, input[name="country[]"]').on('change', function () {
        self.getProductPrice();
      });
      $(document).find('#more-covers').show();
    },
    initStickySidebar: function () {
      var self = this;
      self.$element.find('#sidebar').stickySidebar({
        topSpacing: 200,
        bottomSpacing: 20,
        containerSelector: '.pos-widget',
        innerWrapperSelector: '.sidebar__inner',
        resizeSensor: true,
        stickyClass: 'is-affixed',
        minWidth: 768
      });
    },
    getProductPrice: function () {
      var self = this;
      var product_id = self.$element.find('#duration option:selected').data('id');
      var duration = self.$element.find('#duration').val();
      var adults = parseInt(self.$element.find('#adult').val()) || 0;
      var juniors = parseInt(self.$element.find('#junior').val()) || 0;
      var countries = self.$element.find('input[name="country[]"]:checked').map(function () {
        return this.value;
      }).get();
      if (countries.length === 0 || adults === 0 && juniors === 0 || !duration) {
        return;
      }
      $.ajax({
        url: pos_ajax_obj.ajax_url,
        method: 'POST',
        data: {
          action: 'get_product_price',
          nonce: pos_ajax_obj.nonce,
          product_id: product_id,
          adults: adults,
          juniors: juniors,
          countries: countries,
          duration: duration
        },
        success: function (response) {
          if (response.success) {
            self.$element.find('.basket-amount').html(response.data.price);
          } else {
            var alertHtml = '<div class="alert alert-warning alert-dismissible fade show" role="alert">' + response.data + '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>' + '</div>';
            self.$element.prepend(alertHtml);
            setTimeout(function () {
              self.$element.find('.alert').alert('close');
            }, 6000);
          }
        }
      });
    }
  };
  $(window).on('elementor/frontend/init', function () {
    elementorFrontend.hooks.addAction('frontend/element_ready/cover_pos.default', function ($scope, $) {
      new Cover101Core($scope, $);
    });
  });
})(jQuery);

},{}]},{},[1]);
